module.exports = __webpack_public_path__ + "src/assets/img/page7/921f37585249c08b9a8f2eaea466226d.png";